import React, { useState } from 'react';
import BCCEmailList from '../../components/admin/BCCEmailList';
import BCCEmailForm from '../../components/admin/BCCEmailForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const BCCEmailManagement = () => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleFormSuccess = () => {
    setShowAddForm(false);
    // Trigger a refresh of the email list
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900">BCC Email Management</h1>
        <button
          onClick={() => setShowAddForm(true)}
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          Add New Email
        </button>
      </div>

      {/* Modal for Add Form */}
      {showAddForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div 
            className="bg-white rounded-lg w-full max-w-md mx-4 shadow-xl"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex justify-between items-center p-4 border-b">
              <h2 className="text-xl font-semibold text-gray-900">Add New BCC Email</h2>
              <button
                onClick={() => setShowAddForm(false)}
                className="text-gray-500 hover:text-gray-700 text-xl font-semibold"
              >
                ×
              </button>
            </div>
            <div className="p-4">
              <BCCEmailForm onSuccess={handleFormSuccess} />
            </div>
          </div>
        </div>
      )}

      {/* Email List with refresh trigger */}
      <BCCEmailList key={refreshTrigger} />
    </div>
  );
};

export default BCCEmailManagement; 